import { render } from "./index.vue?vue&type=template&id=54ea0b38&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=54ea0b38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ea0b38"],['__file',"src/components/BaseUi/SelectBox/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54ea0b38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54ea0b38', __exports__)) {
    api.reload('54ea0b38', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=54ea0b38&scoped=true", () => {
    api.rerender('54ea0b38', render)
  })

}


export default __exports__